import axios from "axios";
import APIRoutes from "../../APIRoutes";
import SonicOffer from "../../../common/classes/SonicOffer";
import { getAPIRoot } from "../../../utils/GeneralUtils";
import SonicOfferMeta, {
  SonicOfferMetaData,
} from "../../../common/classes/SonicOfferMeta";

/**
 * getOffers
 *
 * Fetches offer data for myPage.
 *
 * @param auth_token The user's auth token, used for fetching data that requires certain privileges
 * @param page Current page for pagination
 * @param per_page Results per page
 * @returns An array of offers.
 */

export const getOffers = async (
  args: {
    auth_token: string;
    page?: number;
    per_page?: number;
  },
  signal?: AbortSignal
) => {
  try {
    const res = await axios.get(getAPIRoot(APIRoutes.get.offer), {
      headers: {
        "X-Sonic-Auth": args.auth_token,
      },
      params: {
        pg: args.page,
        per: args.per_page,
      },
      signal,
    });

    const offers: Array<SonicOffer> = [];
    const metadatas: Array<SonicOfferMetaData> = [];

    res.data.message.items.forEach((o: any) => {
      const offer = SonicOffer.parseFromAPIResponse(o.offer);
      const meta = SonicOfferMeta.parseFromAPIResponse(o.meta);

      offers.push(offer);
      metadatas.push(meta);
    });

    return {
      total_pages: res.data.message.total_pages,
      page: res.data.message.page,
      total_entries: res.data.message.total_entries,
      offers: offers,
      meta: metadatas,
    };
  } catch (e) {
    return null;
  }
};
